import { brand } from '../brand';

/** Strings shared across pages: shell, navigation, statuses, tiers, generic actions. */

/** Tools from before the no-model rule: they cannot run until the app is scanned again. */
export const rescan = {
  needed: (n: number) => `${n} tool${n === 1 ? '' : 's'} here ${n === 1 ? 'was' : 'were'} set up to be driven by a model at run time, which tools no longer do. Scan the app again to get API calls or replayable steps.`,
  action: 'Scan the app again',
};
export const common = {
  app: {
    name: brand.name,
    tagline: brand.tagline,
  },
  nav: {
    apps: 'Apps',
    connectors: 'Connectors',
    myAgents: brand.id === 'mcpeer' ? 'My peers' : 'My agents',
    connect: 'Connect your agent',
    connections: 'Connections',
    tests: 'Tests',
    audit: 'Audit',
    people: 'People & access',
    organisation: 'Organisation',
    settings: 'Settings',
    signOut: 'Sign out',
    serverHealthy: (version: string) => `Server healthy · v${version}`,
    serverChecking: 'Checking server…',
    serverUnreachable: 'Server unreachable',
    menu: 'Menu',
  },
  topbar: {
    attachApp: 'Connect an app',
  },
  greeting: {
    morning: (name: string) => `Good morning, ${name}`,
    afternoon: (name: string) => `Good afternoon, ${name}`,
    evening: (name: string) => `Good evening, ${name}`,
  },
  people: {
    system: 'system',
    unknown: (idTail: string) => `user …${idTail}`,
  },
  notAvailableYet: 'Not available yet',
  actions: {
    open: 'Open',
    edit: 'Edit',
    save: 'Save changes',
    discard: 'Discard',
    cancel: 'Cancel',
    back: 'Back',
    continue: 'Continue',
    copy: 'Copy',
    copied: 'Copied',
    retry: 'Retry',
    close: 'Close',
    showAll: 'Show all',
    runTests: 'Run tests',
    review: 'Review',
  },
  status: {
    draft: 'draft',
    dev: 'in development',
    pending_approval: 'pending approval',
    live: 'live',
    degraded: 'degraded',
    deprecated: 'deprecated',
  } as Record<string, string>,
  tier: {
    api: 'API',
    browser_scripted: 'Scripted browser',
    browser_ai: 'AI browser',
    browser_ai_recorded: 'AI-recorded flow',
  } as Record<string, string>,
  tierRecordedHint: 'Built once with the AI operator; calls and checks replay the recorded steps with no model.',
  toolKind: {
    read: 'read',
    write: 'write · confirm',
  } as Record<string, string>,
  auditAction: {
    'tool.called': 'Tool called',
    'tool.previewed': 'Write previewed',
    'tool.confirmed': 'Write confirmed',
    'tool.rejected': 'Call rejected',
    'app.created': 'App connected',
    'app.updated': 'App updated',
    'app.status_changed': 'Status changed',
    'preset.published': 'Preset published',
    'connection.created': 'Connected',
    'connection.revoked': 'Connection revoked',
    'test.run': 'Test run',
    'user.signed_in': 'Signed in',
    'org.updated': 'Organisation updated',
    'connector.created': 'Connector created',
    'connector.updated': 'Connector changed',
    'connector.status_changed': 'Connector paused / resumed',
    'connector.access_denied': 'Agent sign-in refused',
    'grant.created': 'Agent authorised',
    'grant.updated': 'Agent tools changed',
    'grant.revoked': 'Agent revoked',
  } as Record<string, string>,
  testKind: {
    contract: 'API checks',
    visual: 'browser flow',
    smoke: 'AI browser',
  } as Record<string, string>,
  testStatus: {
    passed: 'passed',
    failed: 'failed',
    skipped: 'skipped',
    running: 'running',
  } as Record<string, string>,
  connectionState: {
    connected: 'connected',
    expired: 'expired',
    revoked: 'revoked',
    never: 'never connected',
  } as Record<string, string>,
  time: {
    now: 'now',
    inMinutes: (m: number) => `in ${m} min`,
    inHours: (h: number, m: number) => (m ? `in ${h} h ${m} min` : `in ${h} h`),
    inDays: (d: number) => `in ${d} ${d === 1 ? 'day' : 'days'}`,
    justNow: 'just now',
    minutesAgo: (n: number) => `${n}m ago`,
    hoursAgo: (n: number) => `${n}h ago`,
    daysAgo: (n: number) => `${n}d ago`,
    yesterday: 'yesterday',
  },
  empty: {
    nothingHere: 'Nothing here yet.',
    loading: 'Loading…',
  },
  toast: {
    saved: 'Saved',
    error: 'Error',
  },
};
